// test1467
(1467 && 0);
